import { useSupabaseData } from "@/hooks/useSupabaseData";
import { toDriveDirectUrl } from "@/lib/utils";

interface CitaDB {
  id: number;
  texto: string;
  autor?: string;
  cargo?: string;
  sector?: string;
  fecha?: string;
  likes?: number;
  avatar?: string;
}

export default function VocesSection({ vocesTitle = "Voces que construyen salud" }: { vocesTitle?: string }) {
  const { data: citas } = useSupabaseData<CitaDB>("citas", []);
  const vocesCitas = citas.slice(0, 3);

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-white">
      <div className="max-w-[1180px] mx-auto px-4 md:px-8 lg:px-12">
        {/* Título centrado */}
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-[28px] text-masmed-gray-600 tracking-tight">
            {vocesTitle}
          </h2>
        </div>

        {/* Layout escalonado con líneas verticales segmentadas */}
        <div className="flex flex-col gap-8 md:gap-10 lg:gap-12">
          {vocesCitas.map((cita, idx) => (
            <div
              key={cita.id}
              className="flex items-start"
              style={{ marginLeft: `${idx * 40}px` }}
            >
              {/* Tramo de línea vertical naranja */}
              <div className="w-[3px] md:w-1 self-stretch bg-primary rounded-full flex-shrink-0" />

              {/* Contenido: foto + texto */}
              <div className="flex items-start gap-4 md:gap-5 lg:gap-6 ml-4 md:ml-5 lg:ml-6">
                {/* Foto circular */}
                <div className="relative flex-shrink-0 z-10">
                  <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full border-2 border-primary overflow-hidden bg-white">
                    <img
                      src={toDriveDirectUrl(cita.avatar || "")}
                      alt={cita.autor}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Texto del testimonio */}
                <div className="flex-1 min-w-0 pt-2 md:pt-4 lg:pt-5">
                  <p className="text-masmed-gray-900 text-sm md:text-base mb-2 md:mb-3"
                  style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
                    {cita.autor}
                  </p>
                  <p className="text-masmed-gray-500 text-sm md:text-base leading-relaxed">
                    &ldquo;{cita.texto}&rdquo;
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}